export const environment = {
  production: true,
  oldPortalURL: 'https://portal.alphastarcm.com'
};
